import React, { useState } from "react";
import { Modal, Button, Radio, Space } from "antd";

function ModalSelectEmail({ open, setOpen, emails, onEmailSelected }) {
  const [selectedEmail, setSelectedEmail] = useState("");

  const handleCancel = () => {
    setSelectedEmail("");
    setOpen(false);
  };

  const handleNext = () => {
    if (selectedEmail) {
      onEmailSelected(selectedEmail);
      setSelectedEmail("");
      setOpen(false);
    }
  };

  // Filtrăm emailurile pentru a exclude cele care conțin "dobriceansoftware"
  const filteredEmails = emails.filter(email => !email.includes("dobriceansoftware"));

  return (
    <Modal
      title="Selectează emailul pentru schimbarea parolei"
      open={open}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel} style={{ backgroundColor: "red", color: "white" }}>
          Anulează
        </Button>,
        <Button
          key="next"
          onClick={handleNext}
          disabled={!selectedEmail}
          style={{ backgroundColor: "#003d82", color: "white" }}
        >
          Continuă
        </Button>
      ]}
    >
      <div style={{ padding: "20px 0" }}>
        <p>Selectează emailul pentru care dorești să schimbi parola:</p>
        <Radio.Group
          onChange={(e) => setSelectedEmail(e.target.value)}
          value={selectedEmail}
          style={{ width: "100%" }}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            {filteredEmails.map((email, index) => (
              <Radio key={index} value={email} style={{ fontSize: "14px" }}>
                {email}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
        {filteredEmails.length === 0 && (
          <p style={{ color: "gray", textAlign: "center", marginTop: "20px" }}>
            Nu există emailuri disponibile pentru schimbarea parolei.
          </p>
        )}
      </div>
    </Modal>
  );
}

export default ModalSelectEmail;